<template>
  <BRow>
    <BCol cols="2">
      <p class="font-weight-bolder">کد تخفیف</p>
    </BCol>
    <BCol cols="1">
      <p class="font-weight-bolder">نوع کد</p>
    </BCol>
    <BCol cols="1">
      <p class="font-weight-bolder">تاریخ انقضاء</p>
    </BCol>
    <BCol cols="1">
      <p class="font-weight-bolder">بازگشت وجه</p>
    </BCol>
    <BCol cols="1">
      <p class="font-weight-bolder">قابل استفاده</p>
    </BCol>
    <BCol cols="1">
      <p class="font-weight-bolder">استفاده شده</p>
    </BCol>
    <BCol cols="2">
      <p class="font-weight-bolder">حداقل سفارش</p>
    </BCol>
    <BCol cols="1">
      <p class="font-weight-bolder">تخفیف کاربر</p>
    </BCol>
    <BCol cols="2">
      <p class="font-weight-bolder">عملیات</p>
    </BCol>
    <BCol cols="12" class="mt-0">
      <hr class="mt-0" />
    </BCol>
    <MasterDiscountCodeDetailContent
      v-for="(code, index) in discountCodesList"
      :key="index"
      :codeDetails="code"
    ></MasterDiscountCodeDetailContent>
  </BRow>
</template>

<script>
export default {
  props: {
    discountCodesList: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  components: {
    MasterDiscountCodeDetailContent,
    BRow,
    BCol,
  },
};
import MasterDiscountCodeDetailContent from "@/views/components/MasterDiscountCode/MasterDiscountCodeDetailContent.vue";
import { BRow, BCol } from "bootstrap-vue";
</script>
